module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/isarray/index.js
// module id = ./node_modules/react-router/node_modules/isarray/index.js
// module chunks = 0